const Routes = {
    NotFound: 'not-found',
    app: {
        UserManagement: 'user-management',
        UserRegister: 'user-register',
        UserRegisterNew: 'user-register-new',

        SecretarysRegister: 'secretarys-register',
        SecretarysRegisterNew: 'secretarys-register-new',
        SecretarysManagement: 'secretarys-management',

        FundsRegister: 'funds-register',
        FundsRegisterNew: 'funds-register-new',
        //FundsManagement: 'funds-management',

        InstitutionRegister: 'institution-register',
        InstitutionRegisterNew: 'institution-register-new',
        InstitutionManagement: 'institution-management',

        CouncilRegister: 'council-register',
        CouncilRegisterNew: 'council-register-new',
        CouncilManagement: 'council-management',
        CouncilConfig: 'council-config',

        AgentsManagement: 'agents-management',

        Dashboard: 'dashboard',

        Finance: 'finance',

        Receipts: 'receipts',

        Forgot: 'user-forgot-password',
    },
    web: {
        Start: 'start',
        ListDonations: 'list-donations',
        NewDonations: 'new-donations',
        Profile: 'profile',
        UserProfile: 'user-profile',
        AgentProfile: 'agent-profile',
        LandingPage: 'landing-page',
        LoginCouncil: 'login-council',
        Login: 'login',
        ChooseEntity: 'choose-entity',
        Forgot: 'forgot-password',
        CouncilNotActive: 'council-not-active',
        Template: 'template',
        Signature: 'signature',
    },
}

export default Routes
